import gql from 'graphql-tag'

export default gql`mutation go($data: [InvoiceInput]!){
  upsertProjectClientInvoices(data: $data){
    id
  }
  
}`